export default function(ngModule) {
    ngModule.factory('Client', function(BaseClass, $q, $http, $rootScope, Role, $log, $state) {

        const urlPrefix = AUTH_API_ROOT;

        /**
         * Constructor function
         *
         * @param {Object} attributes Initial attributes for the model
         */
        function Client(attributes) {
            _.assign(this, attributes);
        }

        Client.modelName = 'Client';

        BaseClass.apply(Client);
        Client.primaryKey = 'id';

        Client.validates();

        Client.configureApi(urlPrefix + '/clients/:id');
        Object.defineProperties(Client.prototype, {
            toString: {
                value: function() {
                    return `${this.name})`;
                },
                enumerable: false,
                configurable: false
            }
        });

        return Client;
    });
}
